<template>
  <v-layout row justify-center v-if="isLoading">
    <v-dialog v-model="isLoading" persistent content content-class="centered-dialog">
      <v-container fill-height>
        <v-layout column justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" :color="progressColor"></v-progress-circular>
          <h1 v-if="message != null">{{message}}</h1>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
  <v-layout row justify-center v-else>
    <v-flex xs12 md6>
      <v-card>
        <v-flex>
          <div wrap class="camera-modal" style="width: auto">
            <video style="width: 100%" ref="video" class="camera-stream" />
          </div>
        </v-flex>
      </v-card>

      <v-footer fixed>
        <v-bottom-nav :value="true" fixed height="120px">
          <v-btn @click="$router.go('-1')">
            <span>Back</span>
            <v-icon>undo</v-icon>
          </v-btn>
          <v-btn @click="changeCam">
            <span>Change cam</span>
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn @click="capture" :disabled="!getIsOnline">
            <span>Take photo</span>
            <v-icon>camera</v-icon>
          </v-btn>
        </v-bottom-nav>
      </v-footer>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/audits";
import { api as auditApi } from "@/store/modules/audit";
import { api as appApi } from "@/store/modules/app";
import { uploadBlob } from "@/utils/uploader";

export default {
  data: () => ({
    mediaStream: null,
    cameraType: { facingMode: "user" },
    message: null,
    progressColor: "purple"
  }),
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.loading,
      api.getters.getAuditId,
      api.getters.getAuditItemId,
      api.getters.getDeviationId
    ]),
    ...mapGetters(appApi.namespace, [appApi.getters.getIsOnline]),
    isLoading() {
      //return this.$store.getters.loading;
      return this.loading;
    }
  },
  mounted() {
    navigator.mediaDevices
      .getUserMedia({ video: this.cameraType })
      .then(mediaStream => {
        this.mediaStream = mediaStream;
        this.$refs.video.srcObject = mediaStream;
        this.$refs.video.play();
        console.log("Constraints");
        console.log(navigator.mediaDevices.getSupportedConstraints());
      })
      .catch(error => console.error("getUserMedia() error:", error));
  },
  methods: {
    ...mapActions(auditApi.namespace, [auditApi.actions.attachFileToFinding]),
    ...mapActions(appApi.namespace, [appApi.actions.setLoading]),
    changeCam() {
      if (this.cameraType.facingMode === "user") {
        this.cameraType.facingMode = "environment";
      } else {
        this.cameraType.facingMode = "user";
      }

      console.log("Kamera geändert, wenn möglich");
      console.log(this.cameraType.facingMode);

      // Michel: Wie funktioniert das Mounting Konzept oben?

      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: this.cameraType.facingMode } })
        .then(mediaStream => {
          this.mediaStream = mediaStream;
          this.$refs.video.srcObject = mediaStream;
          this.$refs.video.play();
        })
        .catch(error => console.error("getUserMedia() error:", error));
    },
    capture() {
      const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
      const imageCapture = new window.ImageCapture(mediaStreamTrack);

      //this.$store.dispatch("setLoading", true);
      this.setLoading(true);

      return imageCapture
        .takePhoto()
        .then(blob => {
          const imageName = `images/picture-${new Date().getTime()}.jpg`;
          console.log("Upload starten:" + imageName);
          return uploadBlob(blob, imageName, {
            auditId: this.getAuditId,
            auditItemId: this.getAuditItemId,
            findingId: this.getDeviationId
          });
        })
        .then(uploadSnapshot => {
          return uploadSnapshot.ref.getDownloadURL();
        })
        .then(downloadUrl => {
          const payload = {
            audit_id: this.getAuditId,
            audititem_id: this.getAuditItemId,
            deviation_id: this.getDeviationId,
            data: { url: downloadUrl }
          };

          console.log("payload");
          console.log(payload);

          this.attachFileToFinding(payload);
        })
        .then(() => {
          this.setLoading(false);
          this.$router.go(-1);
        })
        .catch(error => {
          console.log("Error Uploading File" + error);
          this.setLoading(false);
        });
    }
  }
};
</script>
